import React from 'react'
import { connect } from 'react-redux'
import { store } from "../store"
import { push } from "react-router-redux"
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import FileList from './widgets/FileList'
import { Link } from 'react-router-dom'
import Nav from './widgets/Nav'
import Util from '../util/util'
import ReactModal from 'react-modal'
import ListErrors from './widgets/ListErrors'
import LogList from './widgets/LogList'
import {
    LOG_LIST_PAGE_LOADED,
    LOG_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import _ from 'lodash'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'
import Pager from 'react-pager'
import { REACT_APP_PAGESIZE } from '../constants/config'

const mapStateToProps = state => ({
    ...state.file,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onLoad: (payload, pageIndex, ) => {
        dispatch({ type: LOG_LIST_PAGE_LOADED, payload, currentPage: pageIndex })
    },
    onUnload: () =>
        dispatch({ type: LOG_LIST_PAGE_UNLOADED }),

})

class Logs extends React.Component {
    constructor() {
        super()
    }
    componentWillMount() {
        if (this.props.currentUser) {
            const pageIndex = 1;
            let payload = agent.Logs.all(pageIndex)
            this.props.onLoad(payload, pageIndex)
        } else {
            store.dispatch(push("/login"))
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }
    handlePageChanged(newPage) {
        const pageIndex = newPage + 1;
        const payload = agent.Logs.all(pageIndex)
        this.props.onLoad(payload, pageIndex);
    }
    render() {
        if (!this.props.logs) {
            return (
                <Loading selected={'logs'} currentUser={this.props.currentUser} />
            )
        }
        const logs = this.props.logs

        return (
            <Translation>
                {
                    (t) => (
                        <div id="main">
                            <Nav selected={'logs'} currentUser={this.props.currentUser} />
                            <div id="content">
                                <Header />
                                <div id="content-wrap">
                                    <div className='box-header'>
                                        <h2> {t('file.log_title')}</h2>
                                    </div>
                                    <LogList data={this.props.logs} loading={this.props.loading} />
                                    {
                                        this.props.logs && this.props.logs.length > 0 && this.props.totalCount > REACT_APP_PAGESIZE ?
                                            <Pager
                                                total={this.props.totalPage || 0}
                                                current={this.props.currentPage - 1}
                                                visiblePages={7}
                                                titles={{ first: '<<', last: '>>' }}
                                                onPageChanged={this.handlePageChanged.bind(this)}
                                            />
                                            : null
                                    }
                                </div>
                            </div>
                        </div >
                    )
                }
            </Translation>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Logs)
